import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Editable } from "@/components/Editable";
import { ImageEditArea } from "@/components/ImageEditArea";
import { useContent } from "@/contexts/ContentContext";
import { CMS } from "@/constants/testIds/cms";

export default function PracticeDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { content } = useContent();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!content) return null;

  const idx = content.modalities.findIndex((m) => m.slug === slug);
  if (idx === -1) {
    navigate("/", { replace: true });
    return null;
  }
  const m = content.modalities[idx];

  return (
    <main id="page-detail">
      <ImageEditArea path={`modalities.${idx}.heroImage`} className="detail-hero" label="Change background" testId={CMS.detailHeroImageEdit}>
        <div className="detail-hero-overlay" />
        <div className="wrap">
          <a className="back-link" onClick={() => navigate("/")}>
            &larr; Back to all practices
          </a>
          <span className="eyebrow">{m.zh}</span>
          <Editable path={`modalities.${idx}.title`} tag="h1" />
        </div>
      </ImageEditArea>
      <section className="detail-body">
        <div className="wrap">
          <Editable path={`modalities.${idx}.longDesc`} tag="p" />
          <ImageEditArea
            path={`modalities.${idx}.bodyImage`}
            className="detail-image"
            label="Change image"
            testId={CMS.detailBodyImageEdit}
          />
          <div className="btn-row">
            <a href={content.link} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              <Editable path="cta.buttonText" />
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
